import cn from 'classnames';
import type { MouseEvent, ReactNode } from 'react';
import type { SidebarMenuItem } from '../../types';
import { getIcon } from './get-icon';
import styles from './styles.module.scss';

type GetSubMenuItemProps = {
  key: string;
  label: string;
  children: SidebarMenuItem[];
  icon?: ReactNode;
  disabled?: boolean;
  className?: string;
  wrapperClassName?: string;
  onClick?: (id: string, event?: MouseEvent<HTMLElement>) => void;
};

export const getSubMenuItem = ({
  key,
  label,
  children,
  icon,
  disabled,
  className,
  wrapperClassName,
  onClick,
}: GetSubMenuItemProps): SidebarMenuItem => {
  const onTitleClick = (event: MouseEvent<HTMLDivElement>) => {
    if (!disabled) {
      onClick?.(key, event);
    }
  };

  return {
    key,
    children,
    disabled,
    className: cn(styles['submenu-item__wrapper'], wrapperClassName),
    label: (
      <div
        className={cn(styles['submenu-item__content'], className)}
        onClick={onTitleClick}
        title={label}
      >
        {icon && <span className={styles['submenu-item__icon']}>{getIcon(icon)}</span>}
        <span className={styles['submenu-item__label']}>{label}</span>
      </div>
    ),
  };
};
